const countriesData = [
  { isoCode: 'AX', name: 'AALAND ISLANDS' },
  { isoCode: 'AF', name: 'AFGHANISTAN' },
  { isoCode: 'AL', name: 'ALBANIA' },
  { isoCode: 'DZ', name: 'ALGERIA' },
  { isoCode: 'AS', name: 'AMERICAN SAMOA' },
  { isoCode: 'AD', name: 'ANDORRA' },
  { isoCode: 'AO', name: 'ANGOLA' },
  { isoCode: 'AI', name: 'ANGUILLA' },
  { isoCode: 'AQ', name: 'ANTARCTICA' },
  { isoCode: 'AG', name: 'ANTIGUA AND BARBUDA' },
  { isoCode: 'AR', name: 'ARGENTINA' },
  { isoCode: 'AM', name: 'ARMENIA' },
  { isoCode: 'AW', name: 'ARUBA' },
  { isoCode: 'AU', name: 'AUSTRALIA' },
  { isoCode: 'AT', name: 'AUSTRIA' },
  { isoCode: 'AZ', name: 'AZERBAIJAN' },
  { isoCode: 'BS', name: 'BAHAMAS' },
  { isoCode: 'BH', name: 'BAHRAIN' },
  { isoCode: 'BD', name: 'BANGLADESH' },
  { isoCode: 'BB', name: 'BARBADOS' },
  { isoCode: 'BY', name: 'BELARUS' },
  { isoCode: 'BE', name: 'BELGIUM' },
  { isoCode: 'BZ', name: 'BELIZE' },
  { isoCode: 'BJ', name: 'BENIN' },
  { isoCode: 'BM', name: 'BERMUDA' },
  { isoCode: 'BT', name: 'BHUTAN' },
  { isoCode: 'BO', name: 'BOLIVIA' },
  { isoCode: 'BA', name: 'BOSNIA AND HERZEGOWINA' },
  { isoCode: 'BW', name: 'BOTSWANA' },
  { isoCode: 'BV', name: 'BOUVET ISLAND' },
  { isoCode: 'BR', name: 'BRAZIL' },
  { isoCode: 'IO', name: 'BRITISH INDIAN OCEAN TERRITORY' },
  { isoCode: 'BN', name: 'BRUNEI DARUSSALAM' },
  { isoCode: 'BG', name: 'BULGARIA' },
  { isoCode: 'BF', name: 'BURKINA FASO' },
  { isoCode: 'BI', name: 'BURUNDI' },
  { isoCode: 'KH', name: 'CAMBODIA' },
  { isoCode: 'CM', name: 'CAMEROON' },
  { isoCode: 'CA', name: 'CANADA' },
  { isoCode: 'CV', name: 'CAPE VERDE' },
  { isoCode: 'KY', name: 'CAYMAN ISLANDS' },
  { isoCode: 'CF', name: 'CENTRAL AFRICAN REPUBLIC' },
  { isoCode: 'TD', name: 'CHAD' },
  { isoCode: 'CL', name: 'CHILE' },
  { isoCode: 'CN', name: 'CHINA' },
  { isoCode: 'CX', name: 'CHRISTMAS ISLAND' },
  { isoCode: 'CO', name: 'COLOMBIA' },
  { isoCode: 'KM', name: 'COMOROS' },
  { isoCode: 'CK', name: 'COOK ISLANDS' },
  { isoCode: 'CR', name: 'COSTA RICA' },
  { isoCode: 'CI', name: 'COTE D\'IVOIRE' },
  { isoCode: 'CU', name: 'CUBA' },
  { isoCode: 'CY', name: 'CYPRUS' },
  { isoCode: 'CZ', name: 'CZECH REPUBLIC' },
  { isoCode: 'DK', name: 'DENMARK' },
  { isoCode: 'DJ', name: 'DJIBOUTI' },
  { isoCode: 'DM', name: 'DOMINICA' },
  { isoCode: 'DO', name: 'DOMINICAN REPUBLIC' },
  { isoCode: 'EC', name: 'ECUADOR' },
  { isoCode: 'EG', name: 'EGYPT' },
  { isoCode: 'SV', name: 'EL SALVADOR' },
  { isoCode: 'GQ', name: 'EQUATORIAL GUINEA' },
  { isoCode: 'ER', name: 'ERITREA' },
  { isoCode: 'EE', name: 'ESTONIA' },
  { isoCode: 'ET', name: 'ETHIOPIA' },
  { isoCode: 'FO', name: 'FAROE ISLANDS' },
  { isoCode: 'FJ', name: 'FIJI' },
  { isoCode: 'FI', name: 'FINLAND' },
  { isoCode: 'FR', name: 'FRANCE' },
  { isoCode: 'GF', name: 'FRENCH GUIANA' },
  { isoCode: 'PF', name: 'FRENCH POLYNESIA' },
  { isoCode: 'TF', name: 'FRENCH SOUTHERN TERRITORIES' },
  { isoCode: 'GA', name: 'GABON' },
  { isoCode: 'GM', name: 'GAMBIA' },
  { isoCode: 'GE', name: 'GEORGIA' },
  { isoCode: 'DE', name: 'GERMANY' },
  { isoCode: 'GH', name: 'GHANA' },
  { isoCode: 'GI', name: 'GIBRALTAR' },
  { isoCode: 'GR', name: 'GREECE' },
  { isoCode: 'GL', name: 'GREENLAND' },
  { isoCode: 'GD', name: 'GRENADA' },
  { isoCode: 'GP', name: 'GUADELOUPE' },
  { isoCode: 'GU', name: 'GUAM' },
  { isoCode: 'GT', name: 'GUATEMALA' },
  { isoCode: 'GN', name: 'GUINEA' },
  { isoCode: 'GW', name: 'GUINEA-BISSAU' },
  { isoCode: 'GY', name: 'GUYANA' },
  { isoCode: 'HT', name: 'HAITI' },
  { isoCode: 'HM', name: 'HEARD AND MC DONALD ISLANDS' },
  { isoCode: 'HN', name: 'HONDURAS' },
  { isoCode: 'HK', name: 'HONG KONG' },
  { isoCode: 'HU', name: 'HUNGARY' },
  { isoCode: 'IS', name: 'ICELAND' },
  { isoCode: 'IN', name: 'INDIA' },
  { isoCode: 'ID', name: 'INDONESIA' },
  { isoCode: 'IQ', name: 'IRAQ' },
  { isoCode: 'IE', name: 'IRELAND' },
  { isoCode: 'IL', name: 'ISRAEL' },
  { isoCode: 'IT', name: 'ITALY' },
  { isoCode: 'JM', name: 'JAMAICA' },
  { isoCode: 'JP', name: 'JAPAN' },
  { isoCode: 'JO', name: 'JORDAN' },
  { isoCode: 'KZ', name: 'KAZAKHSTAN' },
  { isoCode: 'KE', name: 'KENYA' },
  { isoCode: 'KI', name: 'KIRIBATI' },
  { isoCode: 'KW', name: 'KUWAIT' },
  { isoCode: 'KG', name: 'KYRGYZSTAN' },
  { isoCode: 'LA', name: 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC' },
  { isoCode: 'LV', name: 'LATVIA' },
  { isoCode: 'LB', name: 'LEBANON' },
  { isoCode: 'LS', name: 'LESOTHO' },
  { isoCode: 'LR', name: 'LIBERIA' },
  { isoCode: 'LY', name: 'LIBYAN ARAB JAMAHIRIYA' },
  { isoCode: 'LI', name: 'LIECHTENSTEIN' },
  { isoCode: 'LT', name: 'LITHUANIA' },
  { isoCode: 'LU', name: 'LUXEMBOURG' },
  { isoCode: 'MO', name: 'MACAU' },
  { isoCode: 'MG', name: 'MADAGASCAR' },
  { isoCode: 'MW', name: 'MALAWI' },
  { isoCode: 'MY', name: 'MALAYSIA' },
  { isoCode: 'MV', name: 'MALDIVES' },
  { isoCode: 'ML', name: 'MALI' },
  { isoCode: 'MT', name: 'MALTA' },
  { isoCode: 'MH', name: 'MARSHALL ISLANDS' },
  { isoCode: 'MQ', name: 'MARTINIQUE' },
  { isoCode: 'MR', name: 'MAURITANIA' },
  { isoCode: 'MU', name: 'MAURITIUS' },
  { isoCode: 'YT', name: 'MAYOTTE' },
  { isoCode: 'MX', name: 'MEXICO' },
  { isoCode: 'MC', name: 'MONACO' },
  { isoCode: 'MN', name: 'MONGOLIA' },
  { isoCode: 'MS', name: 'MONTSERRAT' },
  { isoCode: 'MA', name: 'MOROCCO' },
  { isoCode: 'MZ', name: 'MOZAMBIQUE' },
  { isoCode: 'MM', name: 'MYANMAR' },
  { isoCode: 'NA', name: 'NAMIBIA' },
  { isoCode: 'NR', name: 'NAURU' },
  { isoCode: 'NP', name: 'NEPAL' },
  { isoCode: 'NL', name: 'NETHERLANDS' },
  { isoCode: 'AN', name: 'NETHERLANDS ANTILLES' },
  { isoCode: 'NC', name: 'NEW CALEDONIA' },
  { isoCode: 'NZ', name: 'NEW ZEALAND' },
  { isoCode: 'NI', name: 'NICARAGUA' },
  { isoCode: 'NE', name: 'NIGER' },
  { isoCode: 'NG', name: 'NIGERIA' },
  { isoCode: 'NU', name: 'NIUE' },
  { isoCode: 'NF', name: 'NORFOLK ISLAND' },
  { isoCode: 'MP', name: 'NORTHERN MARIANA ISLANDS' },
  { isoCode: 'NO', name: 'NORWAY' },
  { isoCode: 'OM', name: 'OMAN' },
  { isoCode: 'PK', name: 'PAKISTAN' },
  { isoCode: 'PW', name: 'PALAU' },
  { isoCode: 'PA', name: 'PANAMA' },
  { isoCode: 'PG', name: 'PAPUA NEW GUINEA' },
  { isoCode: 'PY', name: 'PARAGUAY' },
  { isoCode: 'PE', name: 'PERU' },
  { isoCode: 'PH', name: 'PHILIPPINES' },
  { isoCode: 'PN', name: 'PITCAIRN' },
  { isoCode: 'PL', name: 'POLAND' },
  { isoCode: 'PT', name: 'PORTUGAL' },
  { isoCode: 'PR', name: 'PUERTO RICO' },
  { isoCode: 'QA', name: 'QATAR' },
  { isoCode: 'RE', name: 'REUNION' },
  { isoCode: 'RO', name: 'ROMANIA' },
  { isoCode: 'RU', name: 'RUSSIAN FEDERATION' },
  { isoCode: 'RW', name: 'RWANDA' },
  { isoCode: 'SH', name: 'SAINT HELENA' },
  { isoCode: 'KN', name: 'SAINT KITTS AND NEVIS' },
  { isoCode: 'LC', name: 'SAINT LUCIA' },
  { isoCode: 'PM', name: 'SAINT PIERRE AND MIQUELON' },
  { isoCode: 'VC', name: 'SAINT VINCENT AND THE GRENADINES' },
  { isoCode: 'WS', name: 'SAMOA' },
  { isoCode: 'SM', name: 'SAN MARINO' },
  { isoCode: 'ST', name: 'SAO TOME AND PRINCIPE' },
  { isoCode: 'SA', name: 'SAUDI ARABIA' },
  { isoCode: 'SN', name: 'SENEGAL' },
  { isoCode: 'CS', name: 'SERBIA AND MONTENEGRO' },
  { isoCode: 'SC', name: 'SEYCHELLES' },
  { isoCode: 'SL', name: 'SIERRA LEONE' },
  { isoCode: 'SG', name: 'SINGAPORE' },
  { isoCode: 'SK', name: 'SLOVAKIA' },
  { isoCode: 'SI', name: 'SLOVENIA' },
  { isoCode: 'SB', name: 'SOLOMON ISLANDS' },
  { isoCode: 'SO', name: 'SOMALIA' },
  { isoCode: 'ZA', name: 'SOUTH AFRICA' },
  { isoCode: 'GS', name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS' },
  { isoCode: 'ES', name: 'SPAIN' },
  { isoCode: 'LK', name: 'SRI LANKA' },
  { isoCode: 'SD', name: 'SUDAN' },
  { isoCode: 'SR', name: 'SURINAME' },
  { isoCode: 'SJ', name: 'SVALBARD AND JAN MAYEN ISLANDS' },
  { isoCode: 'SZ', name: 'SWAZILAND' },
  { isoCode: 'SE', name: 'SWEDEN' },
  { isoCode: 'CH', name: 'SWITZERLAND' },
  { isoCode: 'SY', name: 'SYRIAN ARAB REPUBLIC' },
  { isoCode: 'TW', name: 'TAIWAN' },
  { isoCode: 'TJ', name: 'TAJIKISTAN' },
  { isoCode: 'TH', name: 'THAILAND' },
  { isoCode: 'TL', name: 'TIMOR-LESTE' },
  { isoCode: 'TG', name: 'TOGO' },
  { isoCode: 'TK', name: 'TOKELAU' },
  { isoCode: 'TO', name: 'TONGA' },
  { isoCode: 'TT', name: 'TRINIDAD AND TOBAGO' },
  { isoCode: 'TN', name: 'TUNISIA' },
  { isoCode: 'TR', name: 'TURKEY' },
  { isoCode: 'TM', name: 'TURKMENISTAN' },
  { isoCode: 'TC', name: 'TURKS AND CAICOS ISLANDS' },
  { isoCode: 'TV', name: 'TUVALU' },
  { isoCode: 'UG', name: 'UGANDA' },
  { isoCode: 'UA', name: 'UKRAINE' },
  { isoCode: 'AE', name: 'UNITED ARAB EMIRATES' },
  { isoCode: 'GB', name: 'UNITED KINGDOM' },
  { isoCode: 'US', name: 'UNITED STATES' },
  { isoCode: 'UM', name: 'UNITED STATES MINOR OUTLYING ISLANDS' },
  { isoCode: 'UY', name: 'URUGUAY' },
  { isoCode: 'UZ', name: 'UZBEKISTAN' },
  { isoCode: 'VU', name: 'VANUATU' },
  { isoCode: 'VE', name: 'VENEZUELA' },
  { isoCode: 'VN', name: 'VIET NAM' },
  { isoCode: 'WF', name: 'WALLIS AND FUTUNA ISLANDS' },
  { isoCode: 'EH', name: 'WESTERN SAHARA' },
  { isoCode: 'YE', name: 'YEMEN' },
  { isoCode: 'ZM', name: 'ZAMBIA' },
  { isoCode: 'ZW', name: 'ZIMBABWE' },
];

const getCountriesAsArrayOfNames = () => {
  const lst = [];
  countriesData.forEach((item) => {
    lst.push(item.name);
  });
  return lst;
};

const getCountries = () => countriesData;

export default {
  getCountriesAsArrayOfNames,
  getCountries,
};
